import {Basic} from 'types'

export const DEFAULT_CART_ITEM: Basic.CartItem = {
  id: '',
  productId: '',
  optionId: '',
  unitCounters: {},
  availabilityId: '',
}

export const DEFAULT_CART_ITEM_INPUT: Basic.CartItemInput = {
  ...DEFAULT_CART_ITEM,
  date: '',
}
